import 'bootstrap/dist/css/bootstrap.css';
import 'select2/dist/css/select2.css';
import { createApp } from 'vue';
import { messages } from './modules/messages';
import { store } from './store/store';
import App from './App.vue';
import axios from 'axios';
import { createI18n } from 'vue-i18n';
import VueCookies from 'vue-cookies';
import * as helpers from './modules/helpers';
import * as apiImport from './modules/api';
import './jquery_import.js';
import select2 from 'select2';
import 'bootstrap/dist/js/bootstrap.js';
import { v4 as uuidv4 } from 'uuid';

const app = createApp(App);

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$api = apiImport;
app.config.globalProperties.$helpers = helpers;
app.config.globalProperties.$messages = messages;

app.use(VueCookies);

const lang = helpers.paramsToObject().lang || 'sk';

const i18n = new createI18n({
    locale: lang,
    fallbackLocale: 'sk',
    messages,
});

app.use(i18n);
app.use(store);

// Polyfills
if (!String.prototype.repeat) {
    String.prototype.repeat = function (count) {
        'use strict';
        if (this == null)
            throw new TypeError('can\'t convert ' + this + ' to object');

        var str = '' + this;
        // To convert string to integer.
        count = +count;
        // Check NaN
        if (count != count)
            count = 0;

        if (count < 0)
            throw new RangeError('repeat count must be non-negative');

        if (count == Infinity)
            throw new RangeError('repeat count must be less than infinity');

        count = Math.floor(count);
        if (str.length == 0 || count == 0)
            return '';

        // Ensuring count is a 31-bit integer allows us to heavily optimize the
        // main part. But anyway, most current (August 2014) browsers can't handle
        // strings 1 << 28 chars or longer, so:
        if (str.length * count >= 1 << 28)
            throw new RangeError('repeat count must not overflow maximum string size');

        var maxCount = str.length * count;
        count = Math.floor(Math.log(count) / Math.log(2));
        while (count) {
            str += str;
            count--;
        }
        str += str.substring(0, maxCount - str.length);
        return str;
    };
}

if (!Math.trunc) {
    Math.trunc = function (v) {
        v = +v;
        if (!isFinite(v)) return v;

        return (v - v % 1) || (v < 0 ? -0 : v === 0 ? v : 0);

        // returns:
        //  0        ->  0
        // -0        -> -0
        //  0.2      ->  0
        // -0.2      -> -0
        //  0.7      ->  0
        // -0.7      -> -0
        //  Infinity ->  Infinity
        // -Infinity -> -Infinity
        //  NaN      ->  NaN
        //  null     ->  0
    };
}


/**
 * Error handler
 */
app.config.errorHandler = async (err, vm, info) => {
    let message, errorId;

    try {
        const data = JSON.parse(err.message);
        message = data.message;
        errorId = data.errorId;
    } catch {
        message = err.message;
    }

    // it was not error triggered by die method in App component
    if (!errorId) {
        errorId = uuidv4();

        try {
            app._instance.refs.modals.hide("sign");
            app._instance.refs.modals.hide("process");
            app._instance.refs.modals.show(
                "failed",
                true,
                { translate: "generic", errorId }
            );
        } catch (e) {}
    }

    const params = helpers.paramsToObject();
    const sid = store.getters.getOne('sid') || params.state?.split("||")[2] || 'no-sid';

    await apiImport.log({
        sid,
        action: 'error-vue',
        account_client: null,
        account_merchant: null,
        data: {
            message,
            errorId,
            component: vm._?.type?.name,
            info,
        },
    });

    await apiImport.invalidateToken();

    return false;
};

// GLOBAL ERROR HANDLERS
window.onerror = async (msg, _url, lineNo, columnNo, error) => {

    let scripts, message, errorId;

    if (msg.toString() === 'Script error.') {
        try {
            scripts = Array.from(document.scripts)
              .filter(item => item.src)
              .map(item => item.src)
              .toString();
        } catch (e) {}
    }

    try {
        const data = JSON.parse(msg.toString());
        message = data.message;
        errorId = data.errorId;
    } catch {
        message = msg.toString();
    }

    // it was not error triggered by die method in App component
    if (!errorId) {
        errorId = uuidv4();

        try {
            app._instance.refs.modals.hide("sign");
            app._instance.refs.modals.hide("process");
            app._instance.refs.modals.show(
                "failed",
                true,
                { translate: "generic", errorId }
            );
        } catch (e) {}
    }

    const params = helpers.paramsToObject();
    const sid = store.getters.getOne('sid') || params.state?.split("||")[2] || 'no-sid';

    await apiImport.log({
        sid,
        action: 'error-js',
        account_client: null,
        account_merchant: null,
        data: {
            message,
            errorId,
            errorObj: error || null,
            errorLine: lineNo,
            errorColumn: columnNo,
            scripts
        },
    });
    await apiImport.invalidateToken();

    return true;
};

app.mount('#app');

// https://github.com/select2/select2/issues/6081#issuecomment-1043871398
select2();
